var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hkl-card row" },
    [
      _c(
        "HKLCardHeader",
        { staticClass: "small-12" },
        [
          _vm._t("header", function () {
            return [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("HKLCardBody", { staticClass: "small-12" }, [_vm._t("default")], 2),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }